<div class="card border-0">
  <div class="card-body p-3">
    <div class="font-weight-bold mb-2">To establish connection with the current environment</div>
    <table class="table env">
      <tbody>
        <tr>
          <th scope="row" class="firstChild">Name</th>
          <td class="firstChild">{{ currentEnvironment?.name || '' }}</td>
        </tr>
        <tr>
          <th scope="row">Type</th>
          <td>{{ currentEnvironment?.type || '' }}</td>
        </tr>
        <tr>
          <th scope="row">Region</th>
          <td>{{ currentEnvironment?.region || '' }}</td>
        </tr>
        <tr>
          <th scope="row">Server Plan</th>
          <td>{{ currentEnvironment?.serverProfile || '' }}</td>
        </tr>
        <tr>
          <th scope="row" class="lastChild">Operating System</th>
          <td class="lastChild">{{ currentEnvironment?.os || '' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
